<template>
  <div class="homecontent">
    <div ref="tab" class="home-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="home-search">
      <Input suffix="ios-search" placeholder="搜索关键字" style="width: 100%" />
    </div>
    <div class="home-main">
      <empty v-if="approvalList&&approvalList.length<=0"></empty>
      <List v-else>
        <ListItem v-for="(item,index) in approvalList" :key="index">
          <ListItemMeta>
            <template slot="avatar">
              <div
                @click="toInfo(item.applyId,item.applyTypeId)"
                :class="item.applyStatus+'-avatar'"
                class="mis-avatar"
              >
                <span v-if="item.layerText&&item.layerText.length>0">{{item.layerText}}</span>
                <img
                  v-else
                  :src="(item.employeePhotoPath&&item.employeePhotoPath.length>0)?item.employeePhotoPath:require('@/assets/images/defaultHead.png')"
                />
                <div class="status" :class="item.applyStatus+'-status'"></div>
              </div>
            </template>
            <template slot="title">
              <div @click="toInfo(item.applyId,item.applyTypeId)" class="title-box">
                <div class="title-box-item">{{item.applyTypeName}}</div>
                <div>{{item.applyTime}}</div>
              </div>
            </template>
            <template slot="description">
              <div
                @click="toInfo(item.applyId,item.applyTypeId)"
                class="description-item"
              >{{item.layerData}}</div>
              <div
                @click="toInfo(item.applyId,item.applyTypeId)"
                class="description-item"
              >{{item.layerNextData}}</div>
            </template>
          </ListItemMeta>
        </ListItem>
      </List>
    </div>
  </div>
</template>
<script>
import empty from "@/components/Share/Empty";
import tab from "@/components/Share/Tab";
import http from "@/utils/http";
import { mapState } from "vuex";
const { menuItem } = require(`@/config/develop.json`);
export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  data() {
    return {
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "待审批" },
          { key: 1, value: "审批历史" },
          { key: 2, value: "我的申请" }
        ]
      },
      approvalList: []
    };
  },
  methods: {
    tabClickBackFun(index) {
      let url = this.chooseUrl(index);
      let _this = this;
      this.getApprovalList(url, {
        employeeId: this.userInfo.employeeID
      }).then(res => {
        if (res.data.data.length > 0) _this.approvalList = res.data.data;
        else _this.approvalList = [];
      });
    },
    toInfo(applyId, applyTypeId) {
      var url = menuItem[applyTypeId];
      if (url) {
        this.$router.push({
          path: url,
          query: { applyId: applyId, applyTypeId: applyTypeId }
        });
      }
    },
    chooseUrl(index) {
      let url = "";
      switch (index) {
        case 0:
          url = "api/Approval/GetMyApproval";
          break;
        case 1:
          url = "api/Approval/GetApprovalHistory";
          break;
        case 2:
          url = "api/Approval/GetMyApply";
          break;
      }
      return url;
    },
    getApprovalList(url, data) {
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http({ method: "post", url: url, data: data }).then(res => {
          this.$Spin.hide();
          resolve(res);
        });
      });
    }
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.tab.offsetTop;
      _this.$refs.tab.style = "top:" + _this.tabconfig.affixNum + "px";
    });
    this.getApprovalList("api/Approval/GetMyApproval", {
      employeeId: this.userInfo.employeeID
    }).then(res => {
      _this.approvalList = res.data.data;
    });
  },
  components: {
    tab,
    empty
  }
};
</script>
<style lang="less" scoped>
.homecontent {
  padding: 0 0.4rem;
  .home-tab {
    height: 0.6133rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    div {
      flex: 1;
      text-align: center;
      font-size: 0.4rem;
      color: #999;
    }
  }
  .home-search {
    margin-top: 0.8rem;
    /deep/ .ivu-input {
      border: 0;
      border-radius: 0.5333rem;
      background: #f5f5f5;
      height: 1.066667rem;
      font-size: 0.466667rem;
      padding-left: 0.266667rem;
    }
    /deep/ .ivu-input-suffix {
      width: 0.686667rem;
       padding-top: 0.25rem;
      i {
        font-size: 0.586667rem;
      }
    }
  }
  .home-main {
    margin-top: 0.4rem;
    .APPRYES-avatar {
      background: #d9ffd1;
      color: #3cb307;
      border-radius: 50%;
    }
    /* 审批不通过 */

    .APPRNO-avatar {
      background: #ffece9;
      color: #ff5331;
      border-radius: 50%;
    }

    /* 审批中 */

    .SUBMIT-avatar {
      background: #fff4db;
      color: #ffa911;
      border-radius: 50%;
      border-radius: 50%;
    }

    /* 未提交 */

    .SAVE-avatar {
      background: #e2f2ff;
      color: #2a92f5;
      border-radius: 50%;
    }
    .mis-avatar {
      text-align: center;
      white-space: nowrap;
      position: relative;
      vertical-align: middle;
      width: 1.333333rem;
      height: 1.333333rem;
      line-height: 1.3333rem;
      bottom: 0;
      span {
        position: absolute;
        font-size: 0.56rem;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .status {
        width: 0.3733rem;
        height: 0.3733rem;
        border-radius: 50%;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 8;
      }
      .SUBMIT-status {
        background: url("../../assets/icon/deng.png") no-repeat;
        background-size: 100% 100%;
      }
      .APPRYES-status {
        background: url("../../assets/icon/dui.png") no-repeat;
        background-size: 100% 100%;
      }
      .APPRNO-status {
        background: url("../../assets/icon/cuo.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .title-box {
      display: flex;
      .title-box-item {
        flex: 1;
        font-size: 0.4533rem;
      }
    }
    .description-item {
      margin-top: .133333rem;
      font-weight: normal;
      font-size: 0.346667rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
<style>
.ivu-list-item-meta-description {
  line-height: normal !important;
  margin-bottom: .4rem;
}
.ivu-list-item-meta-title {
  line-height: normal !important;
}
.ivu-input-with-suffix {
  padding-right: 0.686667rem !important; 
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/index.vue